import { useEffect, useRef } from 'react';

import { Col, Label, Row } from 'twyne-new.ui';

import { CodeEditor } from '@/components/CodeEditor';

export default function DefaultHelperTab({ helpers, children }) {
  return <>
    {children}
    <Row>
      {helpers.map((helper, index) => <Helper {...helper} key={helper.id} className={index === 0 ? '' : 'mt-3'} />)}
    </Row>
  </>
}

function Helper({ id, label, content, height, annotations, className }) {
  const ref = useRef(null)

  useEffect(() => {
    setTimeout(() => {
      if (ref.current) {
        const { editor } = ref.current
        const notes = annotations.map(annotation => ({ ...annotation, column: 0, type: 'info' }))
        editor
          .getSession()
          .setAnnotations(notes)
      }
    }, 1000)
  }, [annotations])

  return <Col key={id} className={`relative ${className}`}>
    <Label>{label}</Label>
    <CodeEditor
      id={`mode-${id}`}
      ref={ref}
      readOnly={true}
      language='html'
      theme='textmate'
      width='100%'
      value={content}
      height={height}
    />
  </Col>
}
